import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=2ed193f5&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"
import style0 from "../../static/scss/team.scss?vue&type=style&index=0&id=2ed193f5&scoped=true&lang=scss&"
import style1 from "./Team.vue?vue&type=style&index=1&id=2ed193f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed193f5",
  null
  
)

export default component.exports